import { useState } from "react";
import { createSelectorConfirm } from "../../../../utils/createSelectorConfirm";

// mobil has ONE trailer (data_trailer / trailer_id)
const useEditorTrailerDialogs = ({ headerData, setHeaderData }) => {
  const [showTrailerSelector, setShowTrailerSelector] = useState(false);

  const handleOnClickTrailer = () => {
    setShowTrailerSelector(true);
  };

  const handleOnConfirmTrailer = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_trailer",
    idField: "trailer_id",
    setShow: setShowTrailerSelector,
  });

  return {
    showTrailerSelector,
    setShowTrailerSelector,
    handleOnClickTrailer,
    handleOnConfirmTrailer,
  };
};

export default useEditorTrailerDialogs;
